import './cadastro.css';
import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import InputLabel from '../../../rxlib/components/input-label';
import { ApiError, UnidadeNegocio } from '../../../services/tipos';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';

interface UnidadeNegocioCadastroProps {
    show: boolean;
    readOnly: boolean;
    onHide: () => void;
    idOrganizacao: string;
    idUnidadeNegocio: string;
    onSalvar: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function UnidadeNegocioCadastro(props: UnidadeNegocioCadastroProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);

    const [unidadeNegocio, setUnidadeNegocio] = useState<UnidadeNegocio>({
        id: '',
        nome: '',
        sigla: '',
    });

    const { register, handleSubmit } = useForm<UnidadeNegocio>();

    const handleCloseWarning = () => {
        setShowWarning(false);
    }

    const temPermissao = props.readOnly
        ? usuarioTemPermissao(token, 'unidade_visualizar')
        : props.idUnidadeNegocio
            ? usuarioTemPermissao(token, 'unidade_editar')
            : usuarioTemPermissao(token, 'unidade_novo');

    useEffect(() => {
        if (temPermissao) {
            if (props.idUnidadeNegocio) {
                api.get(`/UnidadeNegocio/${props.idUnidadeNegocio}`)
                    .then(response => {
                        setUnidadeNegocio({
                            id: response.data.id,
                            nome: response.data.nome,
                            sigla: response.data.sigla,
                        });
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErroInterno(error);
                    });
            } else {
                setUnidadeNegocio({
                    id: '',
                    nome: '',
                    sigla: '',
                });
            }
        } else {
            setCarregando(false);
            setMessageWarning(['Usuário logado não tem permissão para realizar essa ação com a unidade de negocio.']);
            setShowWarning(true);
        }
    }, [props.idUnidadeNegocio, temPermissao]);

    const onSubmit: SubmitHandler<UnidadeNegocio> = data => {
        setCarregando(true);
        props.idUnidadeNegocio
            ? editar(data)
            : salvar(data);
    }

    function salvar(data: UnidadeNegocio) {
        api.post('/UnidadeNegocio', data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível salvar a unidade: ');
            });
    }

    function editar(data: UnidadeNegocio) {
        api.put('/UnidadeNegocio', data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível salvar a unidade: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onSalvar(true);
        setCarregando(false);
    }

    function tratarErroInterno(error: AxiosError<ApiError>) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, 'Não foi possível carregar a unidade: '));
        setShowWarning(true);
    }

    function getDialogClassName(): string {
        let modalContent: string = (props.idUnidadeNegocio !== '')
            ? 'naja-modal-content-naja-modal-unidade-negocio-view'
            : 'naja-modal-content-naja-modal-unidade-negocio';

        return 'naja-modal-unidade-negocio ' + modalContent;
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} dialogClassName={getDialogClassName()} centered>
                <Modal.Body className='naja-modal-body-detalhe-unidade-negocio'>
                    <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                        <div className='container-fluid'>
                            <div className='row px-1'>
                                <div className='col-11'>
                                    <h6>{props.readOnly ? 'Visualizar' : props.idUnidadeNegocio ? 'Editar' : 'Nova'} unidade</h6>
                                </div>
                                <div className='col-1 naja-btn-close-cell-detalhe-unidade-negocio'>
                                    <button type='button' className='btn-close' aria-label='Close' onClick={props.onHide} />
                                </div>
                            </div>
                            {
                                props.idUnidadeNegocio
                                    ? <div className='row px-1'>
                                        <div className='col-12 mt-1'>
                                            <InputLabel
                                                name='id'
                                                type='text'
                                                maxLength={50}
                                                readOnly={true}
                                                label='Código:'
                                                autoFocus={false}
                                                id='inputIdDetalhe'
                                                placeholder='Código da unidade'
                                                defaultValue={unidadeNegocio.id}
                                                className='rxlib-input-label-coluna'
                                                referencia={register({ required: true })} />
                                        </div>
                                    </div>
                                    : ''
                            }
                            <div className='row px-1 d-none'>
                                <div className='col-12 mt-1'>
                                    <InputLabel
                                        type='text'
                                        maxLength={50}
                                        readOnly={true}
                                        autoFocus={false}
                                        name='idOrganizacao'
                                        id='inputIdOrganizacao'
                                        label='Código da organização:'
                                        defaultValue={props.idOrganizacao}
                                        placeholder='Código da organização'
                                        className='rxlib-input-label-coluna'
                                        referencia={register({ required: true })} />
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-1'>
                                    <InputLabel
                                        name='nome'
                                        type='text'
                                        label='Nome:'
                                        maxLength={50}
                                        autoFocus={true}
                                        id='inputNomeDetalhe'
                                        readOnly={props.readOnly}
                                        placeholder='Nome da unidade'
                                        defaultValue={unidadeNegocio.nome}
                                        className='rxlib-input-label-coluna'
                                        referencia={register({ required: true })} />
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-1'>
                                    <InputLabel
                                        type='text'
                                        name='sigla'
                                        label='Sigla:'
                                        maxLength={10}
                                        autoFocus={false}
                                        id='inputSiglaDetalhe'
                                        readOnly={props.readOnly}
                                        placeholder='Sigla da unidade'
                                        defaultValue={unidadeNegocio.sigla}
                                        className='rxlib-input-label-coluna'
                                        referencia={register({ required: true })} />
                                </div>
                            </div>
                            <ButtonsCrud
                                styleButton='btn-rxlib'
                                carregando={carregando}
                                visualizar={props.readOnly}
                                onCancelarVoltar={props.onHide} />
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <ModalWarning
                show={showWarning}
                message={messageWarning}
                onHide={handleCloseWarning} />
        </>
    );
}

export default UnidadeNegocioCadastro;